import React, { useState } from 'react'
// import { AuditLogTitle, DashboardTitle, DefaultDashboardTitle, LatestActivityTitle } from '../../../Utils/Constants'
// import TotalInvest from './TotalInvest'
// import ManageInvoice from './ManageInvoice'
// import Breadcrumbs from '../../../CommonElements/Breadcrumbs'
import {
    Card,
    CardBody,
    Col,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
    Row,
    Container
} from 'reactstrap';
// import WelcomeBanner from './WelcomeBanner'
// import EarningCard from './EarningCard'
// import JobCard from './JobCard'
// import TransitionHistory from './TransitionHistory'
// import TotalInvestment from '../../../Utils/CommonComponents/CommonDashboard/CommonDefault/TotalInvestment'
// import { auditLogData, investmentChart, latestActivityData } from '../../../Data/Dashboard/Default'
// import CommonListComponent from './Common/CommonListComponent'
// import GrowthCard from '../../../Utils/CommonComponents/CommonDashboard/CommonDefault/GrowthCard'
// import TopUsers from './TopUsers'
// import NewsUpdate from './NewsUpdate'
import ActivityCalendar from '../../../Components/Widgets/ActivityCalendar'
import Todo from '../../../Components/Widgets/Todo'
import PresenzeCalendar from '../../../Components/Widgets/PresenzeCalendar'

export const tabActive = [
    { id: '1', nav: 'Calendario', icon: '', text: 'Calendario' },
    { id: '2', nav: 'Presenze', icon: '', text: 'Presenze' },
    { id: '3', nav: 'Compiti', icon: '', text: 'Compiti' },

];


export default function DefaultDashboard() {

    const [basicTab, setBasicTab] = useState('1');

    return (
        <>
            {/* <Breadcrumbs pageTitle={DefaultDashboardTitle} parent={DashboardTitle} title={DefaultDashboardTitle} paragraph='"Welcome back! Let’s start from where you left."' /> */}
            <Container className='default-dashboard' fluid>
                <Row>
                    {/* <WelcomeBanner />
                    <EarningCard />
                    <JobCard />
                    <TransitionHistory />
                    <CommonListComponent colClass='proorder-xxl-9 box-col-5' title={AuditLogTitle} bodyClass='audit-log' data={auditLogData} />
                    <TotalInvestment colClass="col-xxl-3 col-xl-4 proorder-xxl-3 col-md-6 box-col-6" chartData={investmentChart} height={380} investmentList />
                    <CommonListComponent colClass='proorder-xxl-12 box-col-6' title={LatestActivityTitle} bodyClass='latest-activity' data={latestActivityData} />
                    <GrowthCard colClass='col-lg-6 proorder-xxl-6 box-col-12' cardClass='growthcard' height={350} />
                    <TopUsers />
                    <NewsUpdate />
                    <TotalInvest />
                    <ManageInvoice /> */}

                    <div className="pt-4">
                        <Card className='m-0'>
                            <CardBody>
                                <div className="d-flex">
                                    <Nav className="border-tab border-0 mb-0 nav-danger" pills>
                                        {tabActive.map((item) => (
                                            <NavItem key={item.id}>
                                                <NavLink
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();          // <--- evita il reload
                                                        setBasicTab(item.id);
                                                    }}
                                                    className={`nav-border text-danger nav-danger ${basicTab === item.id ? 'active' : ''
                                                        }`}
                                                >
                                                    <span className="d-inline-flex align-items-center gap-2">
                                                        {item.icon}
                                                        <span>{item.text}</span>
                                                    </span>
                                                </NavLink>
                                            </NavItem>
                                        ))}
                                    </Nav>
                                </div>
                            </CardBody>
                        </Card>
                    </div>


                    <div className="material-content mt-3 w-100">
                        <TabContent activeTab={basicTab}>
                            <TabPane tabId="1">
                                <ActivityCalendar />
                            </TabPane>

                            <TabPane tabId="2">
                                <PresenzeCalendar />
                                
                            </TabPane>

                            <TabPane tabId="3">
                                <Todo />
                            </TabPane>
                        </TabContent>
                    </div>

                </Row>
            </Container>
        </>
    )
}
